/** How often the list is re-fetched while a launched channel is still PENDING. */
export const TRAFFIC_CHANNEL_POLL_INTERVAL_MS = 800;

/**
 * Safety cap (~2 minutes) so a channel stuck in PENDING cannot poll forever;
 * the TRAFFIC_CHANNEL_UPDATES socket reload still refreshes the list after it.
 */
export const TRAFFIC_CHANNEL_POLL_MAX_ATTEMPTS = 150;

export const PSID_UPLOAD_MESSAGES = {
  EMPTY_UPLOAD: 'Invalid or empty PSID list in uploaded file',
  GENERIC_ERROR: 'Something went wrong, try again',
  CLEARED: 'PSID cleared successfully',
} as const;

export function psidUploadedMessage(
  uniqPsidCount: number,
  uploadedPsidCount: number,
): string {
  return `${uniqPsidCount} out of ${uploadedPsidCount} PSID’s were successfully uploaded`;
}

export const TRAFFIC_CHANNEL_ERROR_MESSAGES = {
  LOAD: 'Failed to load traffic channels',
  STATUS_UPDATE: 'Failed to update traffic channel status',
  CPI_UPDATE: 'Failed to update traffic channel CPI',
  LAUNCH: 'Failed to launch traffic channel',
} as const;
